/*jshint browserify: true */
/*global angular*/
'use strict';

angular.module('pdfEdit', [
    // Angular modules 

    // Custom modules 

    // 3rd Party Modules
]);

angular.module('pdfEdit').factory('pdfedit_dialog', require('./dialog.srv.js'));
angular.module('pdfEdit').controller('TestHomeCtrl', require('./test-home.ctrl.js'));
angular.module('pdfEdit').directive('drvPdfRender', require('./pdf-render.directive.js'));

angular.module('pdfEdit').value('pdfedit_fontList', require('../Script/pdf-font-list.js'));
angular.module('pdfEdit').value('pdfedit_zoomPresets', require('../Script/pdf-zoom-presets.js'));